<template>
  <div class="flex items-center">
    <label
      v-for="(item, idx) in items"
      :key="`${id}-item-${idx}`"
      :for="`${id}-${item.value}-${idx}`"
      class="flex items-center gap-1 text-sm font-normal text-cdp-black-500"
    >
      <input
        :id="`${id}-${item.value}-${idx}`"
        v-model="checkboxVal"
        :value="item.value"
        :disabled="props.disabled"
        type="checkbox"
        class="hidden h-4 w-4 border-cdp-grey-400 text-cdp-main-primary accent-cdp-main-primary"
      />
      <icon
        v-show="checkTarget(item.value) && !props.disabled"
        :class="`${className}`"
        name="ic_checkbox_checked_normal"
        class="h-6 w-6 text-cdp-white"
      />
      <icon
        v-show="!checkTarget(item.value) && !props.disabled"
        :class="`${className}`"
        name="ic_checkbox_uncheck_normal"
        class="h-6 w-6 fill-cdp-grey-300"
      />
      <icon
        v-show="checkTarget(item.value) && props.disabled"
        :class="`${className}`"
        name="ic_checkbox_checked_disable"
        class="h-6 w-6 text-cdp-grey-100"
      />
      <icon
        v-show="!checkTarget(item.value) && props.disabled"
        :class="`${className}`"
        name="ic_checkbox_uncheck_disable"
        class="h-6 w-6 text-cdp-grey-400"
      />
      <span class="pr-2">
        {{ item.text }}
      </span>
    </label>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue';
export default defineComponent({
  /**
   * 最初註冊名稱與檔案名稱開頭大小寫不一致，故針對此命名（Histoire 讀檔用）
   */
  name: 'CheckboxGroup',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    id: {
      type: [String, Number],
      default: 'checkbox'
    },
    items: {
      type: Array,
      default: () => [
        {
          text: String,
          value: Number
        }
      ]
    },
    className: {
      type: String,
      default: 'text-cdp-main-primary'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const checkboxVal = computed({
      get: () => props.modelValue,
      set: (val) => {
        emit('update:modelValue', val);
      }
    });

    function checkTarget(target) {
      return props.modelValue.some((key) => key === target);
    }

    return {
      props,
      checkboxVal,
      checkTarget
    };
  }
});
</script>